import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Page,
    Text,
    Card,
    Button,
    BlockStack,
    Icon,
} from '@shopify/polaris';
import {
    LockMajor
} from '@shopify/polaris-icons';
import './index.scss';
// import LightningIcon from '../../../assets/LightningIcon';

// 翻译
import Language from '../../../i18n/Language';
import utils from '../../../utils/utils';
import { connect } from 'react-redux'
import { store } from '../../../redux/store';
import FaqCardBox from '../../../components/FaqCardBox';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;
class SpeedOptimization extends Component {
    state = {
        ShortCard: [
            {
                id: 1,
                icon: <svg width="24" height="24" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.30018 0L10.8499 2.54973L5.09946 8.30018L10.8499 14.0506L8.30018 16.6184L0 8.30018L8.30018 0ZM18.8246 0L27.1248 8.30018L18.8246 16.6184L16.2749 14.0506L22.0253 8.30018L16.2749 2.54973L18.8246 0ZM37.9747 4.68354V26.3834C37.9747 28.3906 36.3653 30 34.358 30H5.42495C4.46576 30 3.54586 29.619 2.86761 28.9407C2.18936 28.2625 1.80832 27.3426 1.80832 26.3834V19.1501H5.42495V26.3834H34.358V4.68354H28.9873V1.06691H34.358C36.3653 1.06691 37.9747 2.67631 37.9747 4.68354Z" fill="#0FA958" />
                </svg>,
                title: 'Meta Tags',
                desc: "Batch generate brief description information of web pages displayed in search results.",
                url: '/searchAppearance/bulk-edit/manual-bulk-edit',
                btn: 'Bulk-edit meta tags',
                btnType: 1, // 1 - primary
                img: '/indoorImg/new/MetaTags.png',
                plan: 2,
                type: 1,
            },
            {
                id: 2,
                icon: <svg width="24" height="24" viewBox="0 0 31 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 17.2133H29M12.5 9.71327H18.5M12.5 24.7133H18.5M23 2.21327H8C4.68629 2.21327 2 4.89956 2 8.21327V26.2133C2 29.527 4.68629 32.2133 8 32.2133H23C26.3137 32.2133 29 29.527 29 26.2133V8.21327C29 4.89956 26.3137 2.21327 23 2.21327Z" stroke="#0FA958" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>,
                title: 'Google Structured Data',
                desc: "Structure your website's content to help Google search engines better understand your pages, resulting in increased visibility.",
                url: '/searchAppearance/structured-data',
                btn: 'Setup Json-LD',
                btnType: 0, // 1 - primary
                img: '/indoorImg/new/jsonld.png',
                plan: 2,
                type: 1,
            },
            {
                id: 3,
                icon: <svg width="24" height="24" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.50615 24.5473C3.72154 25.3827 2 26.5365 2 27.8111C2 30.3604 8.88769 32.4265 17.3846 32.4265C25.8815 32.4265 32.7692 30.3604 32.7692 27.8111C32.7692 26.5365 31.0469 25.3827 28.2631 24.5473" stroke="#0FA958" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M17.3845 26.2727C17.3845 26.2727 27.3845 19.7373 27.3845 12.1819C27.3845 6.79424 22.9076 2.42654 17.3845 2.42654C11.8614 2.42654 7.38452 6.79424 7.38452 12.1819C7.38452 19.7373 17.3845 26.2727 17.3845 26.2727Z" stroke="#0FA958" strokeWidth="3" strokeLinejoin="round" />
                    <path d="M17.3847 16.2727C18.4048 16.2727 19.3831 15.8675 20.1044 15.1462C20.8257 14.4249 21.2309 13.4466 21.2309 12.4265C21.2309 11.4065 20.8257 10.4282 20.1044 9.7069C19.3831 8.9856 18.4048 8.58038 17.3847 8.58038C16.3647 8.58038 15.3864 8.9856 14.6651 9.7069C13.9438 10.4282 13.5386 11.4065 13.5386 12.4265C13.5386 13.4466 13.9438 14.4249 14.6651 15.1462C15.3864 15.8675 16.3647 16.2727 17.3847 16.2727Z" stroke="#0FA958" strokeWidth="3" strokeLinejoin="round" />
                </svg>,
                title: 'Local Business',
                desc: "Enhance your website's local visibility to attract more potential customers in your area.",
                url: '/searchAppearance/local-business',
                btn: 'Setup local business',
                btnType: 0, // 1 - primary
                img: '/indoorImg/new/LocalBusiness.png',
                plan: 2,
                type: 1,
            },
            {
                id: 4,
                icon: <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.625 35L10 35C7.23858 35 5 32.7614 5 30L5 10C5 7.23858 7.23858 5 10 5L30 5C32.7614 5 35 7.23858 35 10L35 15.625" stroke="#0FA958" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M23.25 19.25V27.25M27.25 23.25H19.25M33.75 33.75L30.25 30.25M32.75 23.25C32.75 28.4967 28.4967 32.75 23.25 32.75C18.0033 32.75 13.75 28.4967 13.75 23.25C13.75 18.0033 18.0033 13.75 23.25 13.75C28.4967 13.75 32.75 18.0033 32.75 23.25Z" stroke="#0FA958" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>,
                title: 'Instant Index',
                desc: "Help you quickly submit your URLs to search engines, accelerating the display of your website's content in search results.",
                url: '/searchAppearance/instant-index',
                btn: 'Submit to Google',
                btnType: 0, // 1 - primary
                img: '/indoorImg/new/InstantIndex.png',
                plan: 2,
                type: 1,
            },
            {
                id: 5,
                icon: <svg width="24" height="24" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M15 0.853028C6.71692 0.853028 0 7.56995 0 15.853C0 24.1361 6.71692 30.853 15 30.853C23.2831 30.853 30 24.1361 30 15.853C29.9987 14.848 29.9008 13.8455 29.7077 12.8592C29.6557 12.5974 29.5147 12.3618 29.3085 12.1923C29.1023 12.0229 28.8438 11.9302 28.5769 11.93H15C14.694 11.93 14.4005 12.0515 14.1841 12.2679C13.9677 12.4843 13.8462 12.7778 13.8462 13.0838V18.6223C13.8462 19.2592 14.3631 19.7761 15 19.7761H20.9738C20.5355 20.442 19.9896 21.0306 19.3585 21.5176H19.3554L19.3585 21.5207C18.111 22.4865 16.5776 23.0093 15 23.0069C13.1027 23.0069 11.2831 22.2532 9.94147 20.9116C8.59986 19.57 7.84615 17.7503 7.84615 15.853C7.84615 13.9557 8.59986 12.1361 9.94147 10.7945C11.2831 9.45289 13.1027 8.69918 15 8.69918C16.8215 8.69918 18.4769 9.38533 19.7446 10.5115C19.9646 10.7072 20.251 10.8115 20.5453 10.8029C20.8396 10.7943 21.1195 10.6736 21.3277 10.4653L25.2431 6.54841C25.3526 6.43885 25.439 6.30834 25.497 6.16468C25.5551 6.02101 25.5836 5.86713 25.5809 5.71221C25.5781 5.55729 25.5442 5.4045 25.4812 5.26297C25.4181 5.12143 25.3272 4.99405 25.2138 4.88841C22.4453 2.29495 18.7936 0.852195 15 0.853028ZM19.9262 23.93C18.8393 24.5936 17.6297 25.0309 16.3698 25.2157C15.1099 25.4005 13.8256 25.329 12.594 25.0055C11.3623 24.682 10.2087 24.1131 9.20228 23.3329C8.19584 22.5528 7.3573 21.5774 6.73692 20.4653L4.15692 22.453C5.28916 24.314 6.88152 25.8521 8.78064 26.9191C10.6798 27.9862 12.8216 28.5462 15 28.5453C17.8015 28.5453 20.3923 27.6376 22.4923 26.0992L19.9262 23.93ZM24.2385 24.5546C26.4604 22.2026 27.6964 19.0885 27.6923 15.853C27.6923 15.3176 27.6569 14.7699 27.5923 14.2376H16.1538V17.4684H22.8246C23.0092 17.4684 23.1911 17.5127 23.355 17.5976C23.5189 17.6825 23.6601 17.8054 23.7666 17.9562C23.8732 18.1069 23.942 18.2809 23.9674 18.4638C23.9927 18.6466 23.9738 18.8329 23.9123 19.0069C23.4541 20.3 22.7208 21.4784 21.7631 22.4607L24.24 24.5546H24.2385ZM4.26154 9.08533C5.40448 7.27036 6.98904 5.77488 8.86704 4.73875C10.745 3.70262 12.8551 3.15969 15 3.16072C17.9108 3.16072 20.5846 4.14841 22.7277 5.80072L20.42 8.10841C18.8341 6.9899 16.9407 6.39011 15 6.39149C13.3625 6.39084 11.7528 6.81541 10.3286 7.62364C8.90444 8.43188 7.71453 9.59607 6.87538 11.0023L4.26154 9.08533ZM3.2 11.1684C2.60842 12.6593 2.30561 14.2491 2.30769 15.853C2.30614 17.3844 2.58241 18.9034 3.12308 20.3361L5.84154 18.2407C5.63945 17.4609 5.5376 16.6586 5.53846 15.853C5.53846 14.9207 5.67385 14.0192 5.92462 13.1669L3.2 11.1684Z" fill="#0FA958" />
                </svg>,
                title: 'Google Analytics',
                desc: "Get your website traffic performance",
                url: '/searchAppearance/GoogleSearchConsoleV2',
                btn: 'Connect to Google',
                btnType: 0, // 1 - primary
                img: '/indoorImg/new/GoogleAnaly.png',
                plan: 2,
                type: 1,
            }
        ],
        questionList: {
            sa_wm_seo: {
                title: "What is the impact of Optimizing Search Appearance on SEO?",
                tag: [
                    "Optimizing how your website appears in search results (e.g., meta titles and descriptions) can increase click-through rates (CTR). Although meta descriptions don't directly affect rankings, well-crafted and relevant descriptions can attract more users to click, thereby increasing search traffic. A higher CTR signals to search engines that your page is valuable to users, which may indirectly improve SEO rankings.",
                ]
            },
        }, // 问题列表
        // questionList: {
        //     sa_wm_seo: {
        //         title: "What is the impact of link management on SEO?",
        //         tag: [
        //             "Link management has a significant impact on SEO. A well-structured internal and external linking system helps search engines crawl and index your website content, enhancing page authority. Fixing broken links (such as 404 pages) prevents users and search engines from encountering error pages, improving user experience and maintaining SEO health. Additionally, managing external links ensures that your link sources are authoritative and relevant, thereby enhancing overall SEO performance.",
        //         ]
        //     },
        //     sa_h_uselink: {
        //         title: "How do I use the link management feature?",
        //         tag: [
        //             "1. Use the Broken Links feature to redirect all 404 pages and enable the automatic redirection function. In the future, the system will automatically detect and redirect 404 links.",
        //             "2. Generate an HTML Sitemap to help your website get indexed by Google more quickly, speeding up its appearance in search results.",
        //             "3. In Exchange Backlinks, actively request link exchanges with other websites to enhance your website's authority.",
        //             "4. Use the Backlink Audit feature to continuously monitor your website's external links and maintain their health and validity. This is just our suggested way of using the features, you can  use them in a way that suits your own needs~",
        //         ]
        //     },
        // }, // 问题列表
    }

    // 跳转
    jumpUrl = (url) => {
        utils.routeJump(this, url);
    }

    render() {
        const {
            // LongCard,
            ShortCard,
            questionList,

        } = this.state;

        // 判断是否shopify内嵌模式
        const shopifyMode = store.getState().public.isShowTopMenu || 1;

        // 等级
        const level = store.getState().public.level;

        // 常见问题
        const FrequentAsk = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const lockIcon = (plan = 1) => {
            return <div className='PAY_ICON_NEW'>
                <Icon source={LockMajor} tone="base" /> {plan === 2 ? t("Pro plan") : t("Pre plan")}
            </div>
        }
        const pageContent = <Page
            title={shopifyMode ? t("Search Appearance") : ''}
        >
            <title>SEOAnt - Search Appearance</title>
            <div className={`search_appearance`}>
                <BlockStack gap={400}>
                    <div className='ShortCard'>
                        {
                            ShortCard.map(item => {
                                return <Card key={item.title}>
                                    <div className='ShortCard_Info'>
                                        <div className='SC_img'><img alt='' src={item.img} /></div>
                                        <div className='SC_mes'>
                                            <div className='SC_info'>
                                                <BlockStack gap={200}>
                                                    <div className='flex_layout'>
                                                        <Text variant="headingMd" as="h2">{t(item.title)}</Text>
                                                        {(item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : lockIcon(item.plan)}
                                                    </div>
                                                    <Text as="p" fontWeight="regular">{t(item.desc)}</Text>
                                                </BlockStack>
                                            </div>
                                            <div>
                                                <Button onClick={() => this.jumpUrl(item.url)} variant={Boolean(item?.btnType) && "primary"}>{t(item.btn)}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            })
                        }
                    </div>
                    {FrequentAsk}
                </BlockStack>
            </div>

            {FooterHelpBox}
        </Page>

        return pageContent;
    }
}

const mapStateToProps = state => {
    return state;
}

SpeedOptimization = connect(
    mapStateToProps,
)(SpeedOptimization);

export default withRouter(SpeedOptimization);